/* eslint-disable no-console */ // Turn off the eslint console check just for this file.
// Import utilities for the api.
import { debugEnabled, devEnabled } from './Helpers';

/**
 * The main api class that constructs all other components.
 *
 * @since 5.0.0
 */
export default class Log {
	/**
	 * This title is prepended to all log statements.
	 *
	 * @since 5.0.0
	 */
	static title = '[OptinMonster]';

	/**
	 * This generates a console statement if debug is enabled.
	 *
	 * If the first argument is one of the console methods, then that method will be used instead
	 * of the default, console.warn().
	 *
	 * @since 5.4.3
	 *
	 * @param   {string|Object} method The console method to use. Defaults to the message to be logged.
	 * @param   {string|Object} i The message to be logged if console method is set.
	 * @returns {void}
	 */
	static debug = (method, ...i) => {
		if (!devEnabled() && !debugEnabled()) {
			return;
		}

		const isString = 'string' === typeof method;
		if (!isString || !window.console[method]) {
			i = isString ? method : [...method];
			method = 'warn';
		}

		if ('table' === method) {
			return Log.table(...i);
		}

		const args = isString && !Array.isArray(i) ? [i] : [...i];
		args.unshift(Log.title);
		window.console[method].apply(null, args);
	};

	/**
	 * This generates a console.table statement within a console group.
	 *
	 * @since 5.0.0
	 *
	 * @param   {string|Object} h The message to be logged.
	 * @param   {Object}        t The object that will be turned into a table.
	 * @returns {void}
	 */
	static table = (h, t) => {
		if ('object' === typeof console && 'undefined' !== typeof console.table) {
			console.groupCollapsed([Log.title, h].filter((i) => i).join(' '));
			console.table(t);
			console.groupEnd();
		}
	};
}

// Map methods to Log object.
['log', 'info', 'warn', 'error', 'group', 'groupEnd'].map((method) => {
	/**
	 * Proxies to console methods.
	 *
	 * @param   {string|Object} messages The message(s) to pass.
	 * @returns {void}
	 */
	Log[method] = (...messages) => {
		'object' === typeof console ? console[method].apply(null, [Log.title, ...messages]) : '';
	};
});
